import React, { useState} from 'react';
import '../../styles/Brands-p.css';


const importAll = (r) => {
  return r.keys().map(r);
};


const images = importAll(require.context('../../img/brands/luppa/', false, /\.(webp|jpg|jpeg|png)$/));

const Luppa = () => {
  const [zoomedImg, setZoomedImg] = useState(null); // Estado para controlar el zoom de las imágenes

  // Función para hacer zoom en la imagen
  const handleImageClick = (image) => {
    setZoomedImg(image);
  };

  // Función para cerrar el zoom
  const handleCloseZoom = () => {
    setZoomedImg(null);
  };

  return (
    <div className="netflix-gallery">
      {/* Título y subtítulo */}
      <div className="gallery-header">
        <h1 className="gallery-title">Luppa</h1>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Productora </span> Rayo
        </h2>
      </div>
      {/* Galería de imágenes */}
      <div className="brands-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Brand ${index}`}
            className={`brand-img img-${index % 5}`}
            onClick={() => handleImageClick(image)} // Al hacer clic, hacemos zoom
          />
        ))}
      </div>

      {/* Imagen con zoom */}
      {zoomedImg && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <img src={zoomedImg} alt="Zoomed" className="zoomed-img" />
        </div>
      )}
    </div>
  );
};

export default Luppa;
